// 5) Clic publicar

export const clicPublicar = (dataLayer, { idUsuario, ubicacionBoton }) => {
	dataLayer?.push?.({
		'event': 'clic-publicar',
		'user-id': idUsuario,
		'ubicacion': ubicacionBoton,
	})
}
